import styled from "@xstyled/styled-components";

export const SubmitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
